export default {
  title: 'Logs del sistema',
  name: 'Nombre',
  origin: 'Origen',
  level: 'Nivel',
  affectedEntities: 'Entidades afectadas',
  user: 'Usuario',
  time: 'Tiempo',
  date: 'Fecha',
  cardViewSoon: 'Vista de tarjetas (pronto)'
}
